export default {
  // app广告 =====
  // 上传图片
  AppAdvertisingUpload: "/settings/AppAdvertising/upload",
  // 新增标题内容
  AppAdvertisingAdd: "/settings/AppAdvertising/add",
  // 删除
  AppAdvertisingDelete: "/settings/AppAdvertising/delete",
    // 查询
  AppAdvertisingShow: "/settings/AppAdvertising/show",
  // 上下架时回显数据
  AppAdvertisingShowById: "/settings/AppAdvertising/showById",
  // 上下架排序
  AppAdvertisingUpdateStatus: "/settings/AppAdvertising/updateStatus",
  // 修改广告
  AppAdvertisingUpdate: "/settings/AppAdvertising/update",
  // 删除
  getAppDelete:"/settings/AppAdvertising/delete",
  // 根据ID查看广告详情
  getAppDetail:"/settings/AppAdvertising/showById",
  // 广告上下架排序
  getAppUpdateStatus:"/settings/AppAdvertising/updateStatus",
  // 广告下架
  getUpdateRemove:"/settings/AppAdvertising/updateRemove",
};
